import { Injectable } from '@angular/core';
import { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import { TransitTaskFindInterface } from '@zaoblako/shared/modules/cctv/dtos/transit-task/transit-task-find.dto';
import { TransitTaskPageInterface } from '@zaoblako/shared/modules/cctv/dtos/transit-task/transit-task-page.dto';
import { TransitTaskQueryInterface } from '@zaoblako/shared/modules/cctv/dtos/transit-task/transit-task-query.dto';
import { HikvisionCameraDirectionEnum } from '@zaoblako/shared/modules/cctv/enums/hikvision-camera-direction.enum';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { CardDescriptorInterface } from '@zaoblako/shared/common/dtos/card/card-descriptor.dto';
import type { CommentaryFileFindInterface } from '@zaoblako/shared/modules/storage/dtos/commentary-file/commentary-file-find.dto';
import type { EntityCardHistoryQueryInterface } from '@zaoblako/shared/common/dtos/history/entity-card-history-query.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { TransitTaskUnlinkResidenceEventFormInterface } from '@zaoblako/shared/modules/cctv/dtos/transit-task/transit-task-unlink-residence-event-form.dto';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransitTaskService extends BaseService {
  protected baseUrl = '/cctv/parking/transit-task';

  public getRegistryDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(`${this.baseUrl}/registry-descriptor`);
  }

  public getCardDescriptor(): Observable<CardDescriptorInterface> {
    return this.http.get<CardDescriptorInterface>(`${this.baseUrl}/card-descriptor`);
  }

  public findPage(queryParams: TransitTaskQueryInterface): Observable<TransitTaskPageInterface> {
    return this.http.get<TransitTaskPageInterface>(this.baseUrl, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public restore(id: number): Observable<TransitTaskFindInterface> {
    return this.http.post<TransitTaskFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }

  public getHistory(
    id: number,
    queryParams: EntityCardHistoryQueryInterface | PaginationQueryInterface
  ): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public getFiles(taskId: number): Observable<CommentaryFileFindInterface[]> {
    return this.http.get<CommentaryFileFindInterface[]>(`${this.baseUrl}/${taskId}/files`);
  }

  public passCar(taskId: number, roomId: number): Observable<TransitTaskFindInterface> {
    return this.http.post<TransitTaskFindInterface>(`${this.baseUrl}/${taskId}/pass-car/${roomId}`, null);
  }

  public unlinkResidenceEvent(taskId: number, direction: HikvisionCameraDirectionEnum): Observable<TransitTaskFindInterface> {
    const body: TransitTaskUnlinkResidenceEventFormInterface = { direction };
    return this.http.post<TransitTaskFindInterface>(`${this.baseUrl}/${taskId}/unlink-residence-event`, body);
  }
}
